import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, TextField } from '@tryhackme/thm-ui-components';
import styled from 'styled-components';

export const StyledQuestionContentContainer = styled.div<{ showRemoveIcon: boolean }>`
  flex-grow: 1;
  padding: 1.6rem;
  max-width: ${({ showRemoveIcon }) => (showRemoveIcon ? '832px' : '100%')};
`;

export const StyledDeleteQuestionContainer = styled.div`
  padding-left: 1.6rem;
  padding-right: 1.6rem;
  display: flex;
  align-self: stretch;
  align-items: center;
  border-left: 0.1rem solid ${({ theme }) => theme.colors.border.dropdown};
`;

export const StyledGripIconContainer = styled.div`
  padding: 0.6rem;
  background-color: ${({ theme }) => theme.colors.scrollBar.primary};
  border: 0.1rem solid ${({ theme }) => theme.colors.background.grey};
  border-radius: ${({ theme }) => theme.radius.small};
  position: absolute;
  left: -1.1rem;
  top: 1.7rem;
  display: none;
`;

export const StyledGripIcon = styled(FontAwesomeIcon)`
  font-size: 1.8rem;
  color: ${({ theme }) => theme.colors.grey[600]};
`;

export const StyledQuestionContainer = styled.div<{ isDragging: boolean; isError: boolean }>`
  margin-top: 1.6rem;
  background-color: ${({ theme }) => theme.colors.background.tableOdd};
  border-radius: ${({ theme }) => theme.radius.small};
  border: 0.1rem solid ${({ theme, isError }) => (isError ? theme.colors.error.main : theme.colors.border.dropdown)};
  position: relative;

  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: center;
  opacity: ${({ isDragging }) => (isDragging ? '0' : '1')};
  max-width: 903px;

  &&:hover {
    cursor: grab;
  }

  &&:hover ${StyledGripIconContainer} {
    display: block;
  }

  &&:hover ${StyledQuestionContentContainer} {
    background-color: ${({ theme }) => theme.colors.formSelect.optionHover};
  }

  &&:hover ${StyledDeleteQuestionContainer} {
    background-color: ${({ theme }) => theme.colors.formSelect.optionHover};
  }
`;

export const StyledQuestionNumber = styled.span`
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  font-family: ${({ theme }) => theme.fonts.familySansPro};
  color: ${({ theme }) => theme.colors.text.main};
  font-weight: ${({ theme }) => theme.fonts.weight.bolder};
  display: block;
`;

export const StyledQuestionLabel = styled.span`
  font-size: ${({ theme }) => theme.fonts.sizes.small};
  font-family: ${({ theme }) => theme.fonts.familySansPro};
  color: ${({ theme }) => theme.colors.text.main};
  display: block;
  margin-top: 0.8rem;
  margin-bottom: 0.8rem;
`;

export const StyledPlusIcon = styled(FontAwesomeIcon)`
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  color: ${({ theme }) => theme.colors.text.main};
`;

export const StyledButtonsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.8rem;
  margin-top: 1.6rem;
`;

export const StyledTrashIcon = styled(FontAwesomeIcon)`
  font-size: ${({ theme }) => theme.fonts.sizes.default};
`;

export const StyledQuestionOptionsTextInputWrapper = styled.div`
  margin-top: 1.6rem;
  display: flex;
  gap: 0.8rem;
  align-items: flex-end;
`;

export const StyledQuestionOptionButton = styled(Button)`
  background-color: ${({ theme }) => theme.colors.background.secondary};
  &&:hover {
    svg {
      color: ${({ theme }) => theme.colors.black};
    }
  }
`;

export const StyledQuestionErrorText = styled.div`
  font-size: ${({ theme }) => theme.fonts.sizes.tiny};
  margin-top: 0.6rem;
  color: ${({ theme }) => theme.colors.error.main};
`;

export const StyledInputContainer = styled.div`
  width: 100%;
`;

export const StyledEditorContainer = styled.div`
  cursor: auto;
`;

export const QuestionHeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;
export const QuestionNumberWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const PointsWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 0.4rem;
`;

export const StyledTextField = styled(TextField)`
  width: 4.4rem;
`;
